export function loadScript(url: string, scriptAttributes: object = {}) {
  return new Promise((resolve, reject) => {
    const script: HTMLScriptElement = document.createElement('script');
    const attributes: string[] = Object.keys(scriptAttributes);

    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    script.src = url;

    for (const attr of attributes) {
      script.setAttribute(attr, scriptAttributes[attr]);
    }

    document.head.appendChild(script);
  });
}
